import React, { Fragment, useCallback } from 'react';
import Button from 'components/shared/Button';
import Typo from 'components/shared/Typo';
import LockUnlockConfirmDialog from './LockUnlockConfirmDialog';

function LockUnlockGA2DeviceDialog({ open, locked, ready, rfPath, onCancel, onConfirm }) {
  const handleLock = useCallback(() => onConfirm({ serviceRequest: 'out-of-service-request' }), [onConfirm]);
  const handleUnlock = useCallback(() => onConfirm({ serviceRequest: 'in-service-request' }), [onConfirm]);

  return locked ? (
    <LockUnlockConfirmDialog
      open={open}
      title={
        <Typo as="h3" variant="heading5">
          Put sector {rfPath} <Typo color="primary">in service</Typo>?
        </Typo>
      }
      description={
        !ready && (
          <Typo paragraph variant="body2">
            Sector 1 needs to go through its initial gain configuration process which can last up to 10 minutes. This
            process can cause 5G service interruption on the rest of the sectors in the Pivot GA2 system.
          </Typo>
        )
      }
      actions={
        <Fragment>
          <Button variant="text" color="primary" size="medium" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" size="medium" onClick={handleUnlock}>
            <Typo>
              Yes, put sector <Typo variant="body2">in service</Typo>
            </Typo>
          </Button>
        </Fragment>
      }
    />
  ) : (
    <LockUnlockConfirmDialog
      open={open}
      title={
        <Typo as="h3" variant="heading5">
          Put sector {rfPath} <Typo color="error">out of service</Typo>?
        </Typo>
      }
      description={
        <Typo paragraph variant="body1">
          5G Service will be interrupted on sector.
        </Typo>
      }
      actions={
        <Fragment>
          <Button variant="text" color="primary" size="medium" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="error" size="medium" onClick={handleLock}>
            <Typo>
              Yes, put sector <Typo variant="body2">out of service</Typo>
            </Typo>
          </Button>
        </Fragment>
      }
    />
  );
}

export default LockUnlockGA2DeviceDialog;
